import { contactNumber, facebookLink, whatsappNumber } from "../constants";
import { AppLauncher } from "@capacitor/app-launcher";

export const PhoneData = () => {
  const checkCanOpenUrl = async (url) => {
    const { value } = await AppLauncher.canOpenUrl({ url });
    return value;
  };

  const openUrl = async (url) => {
    if (checkCanOpenUrl()) {
      await AppLauncher.openUrl({
        url,
      });
    } else {
      window.open(url);
    }
  };
  return (
    <div className="hidden md:flex space-x-4 items-center justify-end">
      <div className="flex space-x-4">
        <button
          onClick={() => openUrl(`https://wa.me/${whatsappNumber}`)}
          // href={`https://wa.me/${whatsappNumber}`}
          className="h-10 min-w-10 bg-[#25D366] rounded-full flex justify-center items-center"
        >
          <img
            src="/health/images/whatsapp.svg"
            className="w-5 h-5"
            alt="whatsapp icon"
          />
        </button>
        <button
          className="h-10 min-w-10 bg-[#1877F2] rounded-full flex justify-center items-center"
          // href={facebookLink}
          onClick={() => openUrl(facebookLink)}
        >
          <img
            src="/health/images/facebook.svg"
            className="size-6 relative -top-1"
            alt="facebook icon"
          />
        </button>
      </div>
      <div className="text-4.5 lg:block hidden font-medium font-halyard leading-7 cursor-pointer tracking-normal ">
        {contactNumber}
      </div>
    </div>
  );
};
